import SectionHeading, {
  SectionHeadingType,
} from "@/components/atoms/SectionHeading";
import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import MarqueeCarousel from "@/components/organisms/Carousels/MarqueeCarousel";
import { SuccessStoryType } from "@/shared/types/common.types";
import HomeMarqueeCard from "./Cards/HomeMarqueeCard";
import HomeMarqueeMWebCard from "./Cards/HomeMarqueeMWebCard";

export type HomeMarqueeSectionPropType = {
  title: SectionHeadingType;
  successStoriesSlider1: SuccessStoryType[];
  successStoriesSlider2: SuccessStoryType[];
  cta?: CtaType;
};

const HomeMarqueeSection = ({
  title,
  cta,
  successStoriesSlider1,
  successStoriesSlider2,
}: HomeMarqueeSectionPropType) => {
  return (
    <div className="flex flex-col gap-6 sm:gap-8">
      <div className="container flex items-center justify-between text-start">
        <SectionHeading heading={title} key={"marquee-section" + title} />
        {cta && (
          <div className="hidden sm:block">
            <CtaButtonGroup ctas={[cta]} />
          </div>
        )}
      </div>
      <section className="group/marquee-container pointer-events-none relative -my-20 hidden flex-col gap-6 overflow-hidden py-20 sm:flex">
        <div className="absolute bottom-0 left-0 top-0 z-50 hidden h-full w-40  bg-gradient-to-l from-transparent to-white sm:block"></div>
        <div className="absolute right-0 z-50 hidden h-full w-40  bg-gradient-to-r from-transparent to-white sm:block"></div>
        <MarqueeCarousel pauseOnHover>
          {successStoriesSlider1.map((successStory, index) => (
            <HomeMarqueeCard
              direction="BOTTOM"
              key={index}
              successStory={successStory}
            />
          ))}
        </MarqueeCarousel>
        <MarqueeCarousel pauseOnHover direction="right">
          {successStoriesSlider2.map((successStory, index) => (
            <HomeMarqueeCard
              direction="TOP"
              key={index}
              successStory={successStory}
            />
          ))}
        </MarqueeCarousel>
      </section>

      <section className="group/marquee-container pointer-events-none relative -my-20 flex flex-col gap-6 overflow-hidden py-20 sm:hidden">
        <div className="absolute bottom-0 left-0 top-0 z-50 hidden h-full w-40  bg-gradient-to-l from-transparent to-white sm:block"></div>
        <div className="absolute right-0 z-50 hidden h-full w-40  bg-gradient-to-r from-transparent to-white sm:block"></div>
        <MarqueeCarousel pauseOnHover>
          {[...successStoriesSlider1, ...successStoriesSlider2].map(
            (successStory, index) => (
              <HomeMarqueeMWebCard key={index} successStory={successStory} />
            )
          )}
        </MarqueeCarousel>
      </section>

      {cta && (
        <div className="container sm:hidden">
          <CtaButtonGroup ctas={[cta]} />
        </div>
      )}
    </div>
  );
};

export default HomeMarqueeSection;
